<script lang="ts" setup>
import { ImagePlus } from 'lucide-vue-next'
const props = defineProps<{
  disabled?: boolean
}>()
const emit = defineEmits<{
  (e: 'onSuccess', value?: { url?: string; file?: File }): void
  (e: 'onError'): void
}>()

const iconColor = computed(() =>
  props.disabled ? 'var(--color-gray-200)' : 'var(--color-gray-400)'
)

function onSelect(image?: { url?: string; file?: File }) {
  emit('onSuccess', image)
}
</script>

<template>
  <upload-image @update="onSelect">
    <image-plus :color="iconColor" :stroke-width="1.5" />
  </upload-image>
</template>
